import React from "react";
import { DeclineReasonModal as SharedDeclineReasonModal } from "newui/components/ui/DeclineReasonModal";
import type { DeclineReason } from "../../../../types/clarification-review.type";
import { DECLINE_REASON_LABELS } from "../../../../types/clarification-review.type";

interface DeclineReasonModalProps {
	isOpen: boolean;
	count: number;
	onClose: () => void;
	onConfirm: (reason: string, category: DeclineReason) => void;
	isLoading: boolean;
}

export const DeclineReasonModal: React.FC<DeclineReasonModalProps> = ({
	isOpen,
	count,
	onClose,
	onConfirm,
	isLoading,
}) => {
	return (
		<SharedDeclineReasonModal
			isOpen={isOpen}
			count={count}
			itemLabel="clarification"
			reasons={DECLINE_REASON_LABELS}
			defaultReason="not_relevant"
			onClose={onClose}
			onConfirm={(reason, category) => onConfirm(reason, category as DeclineReason)}
			isLoading={isLoading}
		/>
	);
};
